<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora BAM </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <v-text-field
                v-model="asistencia"
                label="Asistencia"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="asistencia_dis && !puedeEditar"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="reclamo"
                label="Reclamo"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="reclamo_dis && !puedeEditar"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="validarId()"
          v-if="puedeEditar || campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_bam: 0,
      asistencia: "",
      reclamo: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      //
      asistencia_dis: false,
      reclamo_dis: false,
    };
  },
  computed: {
    puedeEditar() {
      return (
        this.$store.state.usuario.rol == "Team Leader Cabina" ||
        this.$store.state.usuario.rol == "Administrador"
      );
    },
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreBam/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_bam = response.data[0].id_cierre_bam;
            this.asistencia = response.data[0].asistencia;
            this.reclamo = response.data[0].reclamo;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (this.asistencia.length > 0 && this.reclamo.length > 0) {
              this.campos_completos = false;
            }

            if (this.asistencia.length > 0) {
              this.asistencia_dis = true;
            }
            if (this.reclamo.length > 0) {
              this.reclamo_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_bam == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_bam > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreBam/Crear",
          {
            idCabina: this.id_cabina,
            asistencia: this.asistencia,
            reclamo: this.reclamo,
          },
          configuracion,
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreBam/Actualizar",
              {
                id_cierre_bam: this.id_cierre_bam,
                idCabina: this.id_cabina,
                asistencia: this.asistencia,
                reclamo: this.reclamo,
              },
              configuracion,
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreBam/Actualizar",
            {
              id_cierre_bam: this.id_cierre_bam,
              idCabina: this.id_cabina,
              asistencia: this.asistencia,
              reclamo: this.reclamo,
            },
            configuracion,
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_bam = 0;
      this.asistencia = "";
      this.reclamo = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>
